/**
 * Prod-host allowlist for browser-side Meta Pixel Lead/Schedule events.
 *
 * Defense-in-depth on top of the Webflow site-wide head guard (added
 * 2026-06-20 after the Jun 3 staging leak): even if some Webflow build,
 * browser extension, or future pixel re-introduces window.fbq on a
 * non-prod host, this gate keeps Meta Lead from firing from a non-prod
 * origin. (The matching server-side gate lived in the Meta CAPI client,
 * removed in PED-111 — this browser-side gate is the remaining one.)
 *
 * Match is exact-host, case-insensitive, no suffix matching (so
 * `evil-ignitionbenefits.com` does not match `ignitionbenefits.com`).
 */

const DEFAULT_PROD_HOSTS = ['ignitionbenefits.com', 'www.ignitionbenefits.com'];

/**
 * Returns true when window.location.hostname is in the configured
 * prod-host allowlist. When `allowlist` is empty/undefined, the default
 * (`ignitionbenefits.com`, `www.ignitionbenefits.com`) is used.
 *
 * Returns false in non-browser contexts (no `window`) so server-side
 * test harnesses default to "not prod" — fail-closed semantics match
 * the server gate.
 */
export function isProdHost(allowlist?: string[]): boolean {
  if (typeof window === 'undefined' || !window.location) return false;
  const host = window.location.hostname.toLowerCase();
  const list = allowlist && allowlist.length > 0 ? allowlist : DEFAULT_PROD_HOSTS;
  for (const entry of list) {
    if (entry.toLowerCase() === host) return true;
  }
  return false;
}
